import { render, staticRenderFns } from "./AppSettingsPanel.vue?vue&type=template&id=33c45b17&scoped=true&"
import script from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
export * from "./AppSettingsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsPanel.vue?vue&type=style&index=0&id=33c45b17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c45b17",
  null
  
)

export default component.exports